<style lang="scss">
    .mealSetting{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
    .head{
        height: 46px;
        padding-top: 10px;
        margin-bottom: 20px;
    h1{
        display: inline;
        margin-left: 20px;
    };
    }
    .layout-breadcrumb{
        padding: 10px 15px 0px ;
        /*border-bottom: 1px solid #e3e3e3;*/
    }
    .layout-content{
        min-height: 80vh;
        margin: 15px;
        overflow: hidden;
        background: #fff;
        border-radius: 4px;
    }
    .layout-content-main{
        padding: 10px;
        .picture{
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 600px;
            padding: 10px;
            /*display: inline-block;*/
        }
        .bg{
            width: 960px;
            height: 540px;
            /*max-width: 100%;*/
            /*max-height: 600px;*/
            margin: 0 auto;
            position: relative;
            background-size: cover;
            background-repeat:no-repeat;
        }
    }
    .footer{
        margin-top: 10px;
        width: 100%;
        height: 46px;
    }

    }




</style>
<template>
    <div class="mealSetting">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >就餐管理</BreadcrumbItem>
                        <BreadcrumbItem >大屏设置</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >大屏设置</h1>

                        </div>
                        <!--<div class="picture" style="text-align: center;">-->
                            <!--<img class="picture"  :src=imgSrc alt="">-->
                        <!--</div>-->
                        <div>
                            <div style="text-align: center;margin-bottom: 10px;">
                                <div style="display: inline-block;">
                                    <Upload
                                            ref="upload"
                                            :on-success="handleSuccess"
                                            :format="['jpg','jpeg','png']"
                                            :max-size="102400"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize"
                                            :action=this.action
                                            :headers=this.headers
                                            :before-upload="beforeUpload"
                                            :show-upload-list="false"
                                            style="display: inline-block;width:58px;"
                                    >
                                        <Button type="primary" icon="ios-cloud-upload-outline" style="margin-left: 100px;">上传大屏背景</Button>
                                    </Upload>
                                    <!--<img style="float:right;" v-show="imgSrc" :src="imgSrc">-->
                                </div>
                                <div style="display: inline-block;margin-left: 200px;font-size: 20px;">
                                    <span>大屏菜单打开后</span>
                                    <InputNumber  :min="0" v-model="second"></InputNumber>
                                    <span>秒自动关闭（0秒为不关闭）</span>
                                </div>
                            </div>
                            <div class="bg">
                                <div style="position: absolute;top: 10%;left: 5%;"><img style="width: 55%;height: auto;margin-right: 5%" src="../../assets/bigScreen/screen_bg1.png" alt=""></div>
                                <div style="display: inline-block;position: absolute;top: 10%;right: 5%;text-align: right;"><img style="width: 55%;height: auto;" src="../../assets/bigScreen/screen_bg2.png" alt=""></div>

                            </div>
                            <p style="text-align: center;font-size: 20px;margin-top: 10px;">预览效果</p>
                        </div>


                    </div>
                    <div style="text-align: center;">
                        <Button style="margin-right: 30px;" @click="saveBackground" type="primary">保存大屏背景</Button>
                        <Button  @click="backBackground" type="primary">还原</Button>
                    </div>
                </div>


            </i-col>

        </Row>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                headers: { token: "swgykj9527" },
                action: parameters.domain + "/sys/bookmealsetting/uploadbg",
                imgSrc: "",
                backSrc: "",
                imgPath:'',
                second:0
            }

        },
        methods: {
            handleSuccess(res){
                console.log(res);
                if(res.code == "0000"){
                    this.$Message.success(res.message);
                    this.imgPath=res.result.path;
                    this.imgSrc=parameters.domain+res.result.path+'?token='+this.getKey('token')
                    $('.bg').css("background-image","url(" + this.imgSrc+ ")")
                    console.log(this.imgSrc);
//                    this.showPicture();
                }else{
                    this.$Message.error(res.message);
                }
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: "图片过大",
                    desc: file.name + " 太大，不能超过10M"
                });
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: "文件格式不正确",
                    desc: "只能是png、jgp和jpeg格式"
                });
            },
            beforeUpload(file){
                this.$refs.upload.clearFiles();
            },
            saveBackground(){
                var that = this;
                let params = {};
                params.url = "/sys/bookmealsetting/savebg";
                params.token = "swgykj9527";
                params.data={image_path:that.imgPath,close_time:that.second};
                console.log(params.data);
                params.success=function(res){
//                    that.imgSrc = "http://192.168.1.158:8080/wtshuiwen/"+res.data.result.result[0].image_path;
                    that.$Notice.success({
                        title: '保存成功'
                    });
                    console.log(res);
                };
                that.ajaxPost(params);
            },
            showPicture(){
                var that = this;
                let params = {};
                params.url = "/sys/bookmealsetting/list";
                params.token = "swgykj9527";
                params.success=function(res){
                    console.log(res);
                    that.imgSrc = parameters.domain+res.data.result.result[0].image_path+'?token='+that.getKey('token');
                    that.backSrc = parameters.domain+res.data.result.result[0].image_path+'?token='+that.getKey('token');
                    that.imgPath=res.data.result.result[0].image_path;
                    that.second=res.data.result.result[0].close_time;
                    $('.bg').css("background-image","url(" + that.imgSrc+ ")")
                };
                that.ajaxPost(params);
            },
            backBackground(){
                $('.bg').css("background-image","url(" + this.backSrc+ ")")
            }
        },
        mounted: function () {
            this.showPicture();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dinnerMana/order.vue